/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/**
 * Controller for the pod management page.
 */
angular.module('nsadmin').controller('podManagementController', ['$scope', '$injector',
    function podManagementController($scope, $injector) {

        var podService = $injector.get('podService');
        var powerControlService = $injector.get('powerControlService');
        var $location = $injector.get('$location');

        /**
         * All pods in the system.
         */
        $scope.pods = [];

        /**
         * All pod devices.
         */
        $scope.podDevices = [];

        /**
         * All shared devices.
         */
        $scope.sharedDevices = [];

        /**
         * New pod form data.
         */
        $scope.newPod = {
            pod_id: '',
            description: ''
        };

        /**
         * New pod device form data.
         */
        $scope.newPodDevice = {
            pod_id: '',
            device_slot: '',
            dev_name: '',
            ip_address: '',
            connection_type: 'ssh',
            apc: '',
            apc_port: ''
        };

        /**
         * New shared device form data.
         */
        $scope.newSharedDevice = {
            device_slot: '',
            dev_name: '',
            ip_address: '',
            connection_type: 'ssh',
            apc: '',
            apc_port: ''
        };

        /**
         * Loading states.
         */
        $scope.loading = {
            pods: true,
            podDevices: true,
            sharedDevices: true
        };

        /**
         * Error messages.
         */
        $scope.errors = {};

        /**
         * Success message.
         */
        $scope.successMessage = null;

        /**
         * Current active tab.
         */
        $scope.activeTab = 'pods';

        /**
         * Loads all pods from the API.
         */
        function loadPods() {
            $scope.loading.pods = true;
            $scope.errors.pods = null;

            podService.getAllPods()
                .then(function success(pods) {
                    $scope.pods = pods.map(function(pod) {
                        pod.editing = false;
                        pod.originalData = angular.copy(pod);
                        return pod;
                    });
                    $scope.loading.pods = false;
                })
                ['catch'](function error(err) {
                    $scope.errors.pods = err.message || 'Failed to load pods';
                    $scope.loading.pods = false;
                });
        }

        /**
         * Loads all pod devices.
         */
        function loadPodDevices() {
            $scope.loading.podDevices = true;

            podService.getAllPodDevices()
                .then(function success(devices) {
                    $scope.podDevices = devices;
                    $scope.loading.podDevices = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading pod devices:', err);
                    $scope.loading.podDevices = false;
                });
        }

        /**
         * Loads all shared devices.
         */
        function loadSharedDevices() {
            $scope.loading.sharedDevices = true;

            podService.getSharedDevices()
                .then(function success(devices) {
                    $scope.sharedDevices = devices;
                    $scope.loading.sharedDevices = false;
                })
                ['catch'](function error(err) {
                    console.error('Error loading shared devices:', err);
                    $scope.loading.sharedDevices = false;
                });
        }

        /**
         * Adds a new pod.
         */
        $scope.addPod = function addPod() {
            $scope.errors.addPod = null;
            $scope.successMessage = null;

            if (!$scope.newPod.pod_id) {
                $scope.errors.addPod = 'Pod ID is required';
                return;
            }

            podService.createPod($scope.newPod)
                .then(function success() {
                    $scope.successMessage = 'Pod added successfully';
                    $scope.newPod = { pod_id: '', description: '' };
                    loadPods();
                })
                ['catch'](function error(err) {
                    $scope.errors.addPod = err.message || 'Failed to add pod';
                });
        };

        /**
         * Starts editing a pod.
         */
        $scope.editPod = function editPod(pod) {
            $scope.pods.forEach(function(p) {
                if (p !== pod && p.editing) {
                    $scope.cancelEditPod(p);
                }
            });

            pod.editing = true;
            pod.originalData = angular.copy(pod);
        };

        /**
         * Saves changes to a pod.
         */
        $scope.savePod = function savePod(pod) {
            $scope.errors.updatePod = null;
            $scope.successMessage = null;

            podService.updatePod(pod.pod_id, { description: pod.description })
                .then(function success() {
                    $scope.successMessage = 'Pod updated successfully';
                    pod.editing = false;
                    pod.originalData = angular.copy(pod);
                })
                ['catch'](function error(err) {
                    $scope.errors.updatePod = err.message || 'Failed to update pod';
                });
        };

        /**
         * Cancels editing a pod.
         */
        $scope.cancelEditPod = function cancelEditPod(pod) {
            pod.description = pod.originalData.description;
            pod.editing = false;
        };

        /**
         * Deletes a pod.
         */
        $scope.deletePod = function deletePod(pod) {
            if (!confirm('Delete pod "' + pod.pod_id + '"? This will also delete all associated devices.')) {
                return;
            }

            $scope.errors.deletePod = null;
            $scope.successMessage = null;

            podService.deletePod(pod.pod_id)
                .then(function success() {
                    $scope.successMessage = 'Pod deleted successfully';
                    loadPods();
                    loadPodDevices();
                })
                ['catch'](function error(err) {
                    $scope.errors.deletePod = err.message || 'Failed to delete pod';
                });
        };

        /**
         * Adds a pod device.
         */
        $scope.addPodDevice = function addPodDevice() {
            $scope.errors.addPodDevice = null;
            $scope.successMessage = null;

            if (!$scope.newPodDevice.pod_id || !$scope.newPodDevice.device_slot) {
                $scope.errors.addPodDevice = 'Pod ID and Device Slot are required';
                return;
            }

            podService.addPodDevice($scope.newPodDevice.pod_id, $scope.newPodDevice)
                .then(function success() {
                    $scope.successMessage = 'Pod device added successfully';
                    $scope.newPodDevice = {
                        pod_id: '',
                        device_slot: '',
                        dev_name: '',
                        ip_address: '',
                        connection_type: 'ssh',
                        apc: '',
                        apc_port: ''
                    };
                    loadPodDevices();
                })
                ['catch'](function error(err) {
                    $scope.errors.addPodDevice = err.message || 'Failed to add pod device';
                });
        };

        /**
         * Deletes a pod device.
         */
        $scope.deletePodDevice = function deletePodDevice(device) {
            if (!confirm('Delete device "' + device.dev_name + '"?')) {
                return;
            }

            $scope.successMessage = null;

            podService.deletePodDevice(device.pod_id, device.device_slot)
                .then(function success() {
                    $scope.successMessage = 'Pod device deleted successfully';
                    loadPodDevices();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to delete pod device'));
                });
        };

        /**
         * Adds a shared device.
         */
        $scope.addSharedDevice = function addSharedDevice() {
            $scope.errors.addSharedDevice = null;
            $scope.successMessage = null;

            if (!$scope.newSharedDevice.device_slot) {
                $scope.errors.addSharedDevice = 'Device Slot is required';
                return;
            }

            podService.addSharedDevice($scope.newSharedDevice)
                .then(function success() {
                    $scope.successMessage = 'Shared device added successfully';
                    $scope.newSharedDevice = {
                        device_slot: '',
                        dev_name: '',
                        ip_address: '',
                        connection_type: 'ssh',
                        apc: '',
                        apc_port: ''
                    };
                    loadSharedDevices();
                })
                ['catch'](function error(err) {
                    $scope.errors.addSharedDevice = err.message || 'Failed to add shared device';
                });
        };

        /**
         * Deletes a shared device.
         */
        $scope.deleteSharedDevice = function deleteSharedDevice(device) {
            if (!confirm('Delete shared device "' + device.dev_name + '"?')) {
                return;
            }

            $scope.successMessage = null;

            podService.deleteSharedDevice(device.device_slot)
                .then(function success() {
                    $scope.successMessage = 'Shared device deleted successfully';
                    loadSharedDevices();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to delete shared device'));
                });
        };

        /**
         * Powers on/off a pod device.
         */
        $scope.powerPodDevice = function powerPodDevice(device, state) {
            var action = state === 1 ? 'on' : 'off';
            $scope.successMessage = null;

            powerControlService.powerPodDevice(device.pod_id, device.device_slot, state)
                .then(function success() {
                    $scope.successMessage = 'Device powered ' + action + ' successfully';
                    device.pwr_status = state;
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to power ' + action + ' device'));
                });
        };

        /**
         * Powers on/off a shared device.
         */
        $scope.powerSharedDevice = function powerSharedDevice(device, state) {
            var action = state === 1 ? 'on' : 'off';
            $scope.successMessage = null;

            powerControlService.powerSharedDevice(device.device_slot, state)
                .then(function success() {
                    $scope.successMessage = 'Shared device powered ' + action + ' successfully';
                    device.pwr_status = state;
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to power ' + action + ' device'));
                });
        };

        /**
         * Powers on/off an entire pod.
         */
        $scope.powerPod = function powerPod(pod, state) {
            var action = state === 1 ? 'on' : 'off';
            if (!confirm('Power ' + action + ' all devices in pod "' + pod.pod_id + '"?')) {
                return;
            }

            $scope.successMessage = null;

            powerControlService.powerPod(pod.pod_id, state)
                .then(function success() {
                    $scope.successMessage = 'Pod powered ' + action + ' successfully';
                    loadPodDevices();
                })
                ['catch'](function error(err) {
                    alert('Error: ' + (err.message || 'Failed to power ' + action + ' pod'));
                });
        };

        /**
         * Switches to a different tab.
         */
        $scope.switchTab = function switchTab(tab) {
            $scope.activeTab = tab;
            $scope.clearMessages();
        };

        /**
         * Clears success/error messages.
         */
        $scope.clearMessages = function clearMessages() {
            $scope.successMessage = null;
            $scope.errors = {};
        };

        /**
         * Navigates back to the dashboard.
         */
        $scope.goToDashboard = function goToDashboard() {
            $location.path('/nsadmin/dashboard');
        };

        // Load data on controller initialization
        loadPods();
        loadPodDevices();
        loadSharedDevices();

        console.log('Pod Management controller loaded');
    }
]);
